import script from "./AddToListPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddToListPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AddToListPopup.vue?vue&type=style&index=0&id=06af9b31&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06af9b31"]])

export default __exports__